import WIPProduksiAsetApi from "./WIPProduksiAsetApi";

export default WIPProduksiAsetApi;
